<script setup lang="ts">
import type { components } from '~/generated/types'

import { computed } from 'vue'
import { useStore } from '~/store'

import { to } from '~/routing'

import Card from '~/ui/Card.vue'

// TODO: use FullActor when we have a different endpoint for remote user search to get user avatars -->
interface Props {
  actor: components['schemas']['Actor']
  follower?: boolean
  following?: boolean
  isOwnProfile?: boolean
}

const props = defineProps<Props>()

const store = useStore()
const localurl = store.getters['instance/domain']


function getDomain(id: string): string {
  const url = new URL(id)
  return url.hostname
}

const domain = getDomain(props.actor.id)

const description = computed(() => {
  return props.actor.summary?.length && props.actor.summary.length > 50
    ? props.actor.summary.slice(0, 50) + '...'
    : props.actor.summary || ''
})

const isChannel = computed(() =>
  props.actor.category === 'podcast' || props.actor.category === 'music'
)

const cardLink = computed(() => isChannel.value
  ? to({ name: 'channels.detail', params: { id: props.actor.name + '@' + domain } })
  : to({ name: 'profile.full.content', params: { username: props.actor.name, domain } })
)
</script>

<template>
  <Card
    :title="actor.name ?? ''"
    v-bind="cardLink"
    small
  >
    <template #image="{ circle }">
      <!-- TODO: add " || actor.icon.urls.medium_square_crop" to v-lazy if FullActor is used in search to get avatar support -->
      <img
        v-if="actor.icon"
        v-bind="actor.category !== 'podcast' ? circle() : undefined"
        v-lazy="actor.icon.url"
        :alt="actor.name || undefined"
        style="object-fit: cover;"
      >
      <Icon
        v-else
        :icon="actor.category === 'podcast' ? 'bi:mic' : 'bi:person-circle'"
        :class="actor.category === 'podcast' ? 'podcast-icon' : 'music-icon'"
      />
    </template>

    <div v-text="description" />

    <template
      v-if="domain && domain != localurl"
      #footer
    >
      <span class="font-small layout-row" ui-block-size="40" ui-nowrap ui-gap="8" style="padding: 16px; overflow: hidden;">
        <Icon icon="bi:globe" />
        <span :title="domain" style="overflow: hidden; text-overflow: ellipsis;">{{ domain }}</span>
      </span>
    </template>
  </Card>
</template>

<style scoped>
.podcast-icon {
  width: 100%;
  height: 100%;
  padding: 48px;
  background-color: var(--color-300);
}

.music-icon {
  width: 100%;
  height: 100%;
  padding: 16px;
}
</style>
